import React from 'react'
import './Banner.css'
import { Button } from "@material-ui/core"
import { useHistory } from 'react-router-dom'

function Banner () {
    
    const history = useHistory();
    
    return (
        <div className='banner'>
            <div className='banner__info'>
                <h1>Bienvenido a Ahavá !</h1>
                <h5>
                    Estás en la pantalla del Aviso de Privacidad. 
                    Para leer los Términos y Condiciones, da click en el botón 
                    de abajo.
                </h5>

                
                    <Button onClick={() => history.push('./terms')}
                        variant='outlined'>
                        Leer los Términos y Condiciones</Button>

                    <Button onClick={() => history.push('./support')}
                        variant='outlined'>
                        Contactarme con Soporte</Button>
            </div>
        </div>
    )
}

export default Banner
